(() => {
  const ageOptions = [
    { value: 'child', key: 'age-child', label: 'Kind', detailKey: 'age-child-detail', detail: '6–11 Jahre', icon: '🧸' },
    { value: 'teen', key: 'age-teen', label: 'Jugendliche', detailKey: 'age-teen-detail', detail: '12–17 Jahre', icon: '🎨' },
    { value: 'adult', key: 'age-adult', label: 'Erwachsene', detailKey: 'age-adult-detail', detail: 'Ab 18 Jahren', icon: '✨' }
  ];
  const interestOptions = [
    { value: 'raetselboxen-fuer-erwachsene', key: 'interest-riddle', label: 'Rätsel & Knobeln', image: 'https://cdn.shopify.com/s/files/1/0290/4064/0079/files/as-mh-0176-raetsel.png?v=1785827490' },
    { value: 'mechanische-3d-holzmodelle', key: 'interest-technology', label: 'Technik & Mechanik', image: 'https://cdn.shopify.com/s/files/1/0290/4064/0079/files/as-mh-0176-technik.png?v=1785827490' },
    { value: 'miniatur-haus-bausatz-diy', key: 'interest-miniature', label: 'Miniaturwelten', image: 'https://cdn.shopify.com/s/files/1/0290/4064/0079/files/as-mh-0176-kreativ.png?v=1785827490' },
    { value: 'magisches-holzpuzzle', key: 'interest-puzzle', label: 'Holzpuzzles & Design', image: 'https://cdn.shopify.com/s/files/1/0290/4064/0079/files/as-mh-0176-auszeit.png?v=1785827490' },
    { value: 'murmelbahn-holz-bausatz', key: 'interest-marble', label: 'Murmelbahnen', icon: '🎢' },
    { value: 'harry-potter-puzzle', key: 'interest-potter', label: 'Harry Potter™', icon: '🪄' }
  ];
  const budgetOptions = [
    { value: 'under30', key: 'budget-low', label: 'Unter 30 €', icon: '🎁' },
    { value: '30to60', key: 'budget-mid', label: '30 bis unter 60 €', icon: '💝' },
    { value: 'over60', key: 'budget-high', label: 'Ab 60 €', icon: '⭐' }
  ];
  const ageFilters = {
    child: ['6+'],
    teen: ['6+', '10+', '12+']
  };

  function init(root) {
    if (root.dataset.gfReady === 'true') return;
    root.dataset.gfReady = 'true';
    const progress = root.querySelector('[data-gf-progress]');
    const question = root.querySelector('[data-gf-question]');
    const status = root.querySelector('[data-gf-status]');
    const back = root.querySelector('[data-gf-back]');
    const skip = root.querySelector('[data-gf-skip]');
    const dictionary = root.querySelector('[data-gf-dictionary]');
    const textNodes = new Map([...(dictionary?.querySelectorAll('[data-gf-key]') || [])].map((item) => [item.dataset.gfKey, item]));
    const collectionsBase = (root.dataset.collectionsUrl || '/collections').replace(/\/+$/, '');
    const t = (key, fallback) => textNodes.get(key)?.textContent.trim() || fallback;
    const titleTag = root.classList.contains('mh-gf--page') ? 'h2' : 'h3';
    const recipientNodes = [...root.querySelectorAll('[data-gf-recipient]')];
    function recipientOptions() {
      const configured = recipientNodes
        .filter((item) => ['giftOption', 'selfOption'].includes(item.dataset.value))
        .map((item) => ({ value: item.dataset.value, label: item.textContent.trim() || item.dataset.label, image: item.dataset.image }));
      return configured.length ? configured : [
        { value: 'giftOption', label: t('recipient-gift', 'Für jemanden 🎁'), icon: '🎁' },
        { value: 'selfOption', label: t('recipient-self', 'Für mich selbst 😍'), icon: '😍' }
      ];
    }
    const state = { step: 0, answers: { recipient: null, age: null, interest: null, budget: null }, request: 0, renderVersion: 0 };
    const cache = new Map();

    function event(name, detail = {}) {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('magicholz:quiz_' + name, {
          quiz_id: 'gift-finder-v4', page_path: location.pathname, ...detail
        });
      }
    }

    function node(tag, className, content) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (content !== undefined) element.textContent = content;
      return element;
    }

    function setProgress(step) {
      progress.replaceChildren();
      if (step === 4) return;
      progress.appendChild(node('div', '', t(`progress-${step + 1}`, `Schritt ${step + 1} von 4`)));
      const track = node('span');
      const fill = node('i');
      fill.style.width = `${(step + 1) * 25}%`;
      track.appendChild(fill);
      progress.appendChild(track);
    }

    function renderQuestion(focusHeading = false) {
      const renderVersion = ++state.renderVersion;
      root.classList.remove('mh-gf--results');
      question.replaceChildren();
      status.textContent = '';
      status.classList.remove('mh-gf__status--loading');
      const step = state.step;
      setProgress(step);
      back.hidden = step === 0;
      skip.hidden = step === 0;
      back.textContent = t('back', 'Zurück');
      skip.textContent = t('skip', 'Keine Präferenz');

      const recipient = state.answers.recipient === 'selfOption';
      const steps = [
        { heading: t('recipient-heading', 'Für wen suchst du?'), hint: t('recipient-hint', 'Wähle aus, und wir führen dich direkt weiter.'), options: recipientOptions() },
        { heading: recipient ? t('age-heading-self', 'Welche Altersgruppe passt zu dir?') : t('age-heading-gift', 'Welche Altersgruppe passt?'), hint: t('age-hint', 'Eine grobe Auswahl reicht. Du kannst diesen Schritt überspringen.'), options: ageOptions },
        { heading: recipient ? t('interest-heading-self', 'Was macht dir Freude?') : t('interest-heading-gift', 'Was könnte Freude machen?'), hint: t('interest-hint', 'Ein Thema reicht. Wenn du unsicher bist, überspringe diesen Schritt.'), options: interestOptions },
        { heading: t('budget-heading', 'Welches Budget passt?'), hint: t('budget-hint', 'Wir zeigen dir anschließend konkrete Geschenkideen.'), options: budgetOptions }
      ];
      const config = steps[step];
      const heading = node(titleTag, '', config.heading);
      heading.tabIndex = -1;
      question.appendChild(heading);
      question.appendChild(node('p', 'mh-gf__hint', config.hint));
      const options = node('div', 'mh-gf__options');
      const choices = [];
      config.options.forEach((option) => {
        const button = node('button', 'mh-gf__option');
        button.type = 'button';
        if (option.image) {
          const image = node('img');
          image.src = option.image;
          image.alt = '';
          image.loading = 'lazy';
          button.appendChild(image);
        } else {
          button.appendChild(node('span', 'mh-gf__option-icon', option.icon || '🎁'));
        }
        const copy = node('span', 'mh-gf__option-copy');
        copy.appendChild(node('span', '', option.key ? t(option.key, option.label) : option.label));
        if (option.detail) copy.appendChild(node('small', 'mh-gf__option-detail', t(option.detailKey, option.detail)));
        let countLabel = null;
        if (step === 2 || step === 3) {
          countLabel = node('small', 'mh-gf__count', t('count-loading', 'Verfügbarkeit wird geprüft …'));
          copy.appendChild(countLabel);
          button.classList.add('mh-gf__option--loading');
          button.setAttribute('aria-busy', 'true');
        }
        button.appendChild(copy);
        button.addEventListener('click', () => choose(option.value));
        options.appendChild(button);
        choices.push({ option, button, countLabel });
      });
      question.appendChild(options);
      if (focusHeading) heading.focus();
      if (step === 2 || step === 3) loadCounts(step, choices, renderVersion);
    }

    async function loadCounts(step, choices, renderVersion) {
      const results = await Promise.all(choices.map(async ({ option }) => {
        try {
          const handle = step === 2 ? option.value : (state.answers.interest || 'geschenkefinder');
          const budget = step === 3 ? option.value : null;
          return await collectionData(handle, budget);
        } catch (_) {
          return null;
        }
      }));
      if (renderVersion !== state.renderVersion) return;
      let zeroCount = 0;
      choices.forEach(({ button, countLabel }, index) => {
        button.classList.remove('mh-gf__option--loading');
        button.removeAttribute('aria-busy');
        const count = results[index]?.count;
        if (count === null || count === undefined) {
          countLabel.textContent = t('count-unavailable', 'Anzahl gerade nicht verfügbar');
          return;
        }
        countLabel.textContent = `${count} ${count === 1 ? t('gift-singular', 'Geschenk') : t('gift-plural', 'Geschenke')}`;
        if (count === 0) {
          zeroCount += 1;
          button.disabled = true;
          button.classList.add('mh-gf__option--empty');
        }
      });
      if (zeroCount === choices.length) {
        status.textContent = t('all-zero', 'Hier gibt es gerade keine Treffer. Gehe zurück oder wähle „Keine Präferenz“.');
      }
    }

    function choose(value) {
      const keys = ['recipient', 'age', 'interest', 'budget'];
      const key = keys[state.step];
      if (state.step === 0) event('start', { entry_point: location.pathname });
      state.answers[key] = value;
      keys.slice(state.step + 1).forEach((later) => { state.answers[later] = null; });
      event('step', { step_index: state.step + 1, category: key, value });
      state.step += 1;
      if (state.step === 4) showResults();
      else renderQuestion(true);
    }

    function plainCollectionUrl(handle) {
      return `${collectionsBase}/${encodeURIComponent(handle)}`;
    }

    function collectionUrl(handle, budget = state.answers.budget) {
      const params = new URLSearchParams();
      params.set('sort_by', 'best-selling');
      params.set('filter.v.availability', '1');
      (ageFilters[state.answers.age] || []).forEach((value) => {
        params.append('filter.p.m.my_fields.ageRange', value);
      });
      if (budget === 'under30') params.set('filter.v.price.lte', '29.99');
      if (budget === '30to60') {
        params.set('filter.v.price.gte', '30');
        params.set('filter.v.price.lte', '59.99');
      }
      if (budget === 'over60') params.set('filter.v.price.gte', '60');
      return `${plainCollectionUrl(handle)}?${params.toString()}`;
    }

    function parseCards(doc) {
      return [...doc.querySelectorAll('.product-facet__product-list .product-list__inner product-item')]
        .filter((item) => !item.classList.contains('product-item--sold-out'))
        .map((item) => {
          const titleLink = item.querySelector('a.product-item-meta__title');
          const rawUrl = titleLink?.getAttribute('href');
          if (!rawUrl) return null;
          const url = new URL(rawUrl, location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
          const image = item.querySelector('img.product-item__primary-image');
          const rawImage = image?.getAttribute('src');
          const price = item.querySelector('.product-item-meta__price-list-container .price:not(.price--compare) .wg-notranslate')
            || item.querySelector('.product-item-meta__price-list-container .price:not(.price--compare)');
          return {
            url: url.pathname + url.search,
            title: titleLink.textContent.trim(),
            image: rawImage ? new URL(rawImage, location.origin).href : '',
            imageAlt: image?.getAttribute('alt') || '',
            price: price?.textContent.replace(/\s+/g, ' ').trim() || '',
            vendor: item.querySelector('.product-item-meta__vendor')?.textContent.trim() || ''
          };
        })
        .filter(Boolean);
    }

    async function collectionData(handle, budget = state.answers.budget) {
      const url = collectionUrl(handle, budget);
      if (!cache.has(url)) {
        const pending = fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
          .then(async (response) => {
            if (!response.ok) throw new Error('Kollektion nicht erreichbar');
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const countElement = doc.querySelector('.product-facet__meta-bar-item--count');
            const grid = doc.querySelector('.product-facet__product-list .product-list__inner');
            const emptyState = doc.querySelector('#facet-main .empty-state');
            if (!countElement && !grid && !emptyState) throw new Error('Kollektion nicht lesbar');
            const cards = parseCards(doc);
            const number = countElement?.textContent.match(/[\d.,]+/)?.[0];
            const parsed = number ? Number(number.replace(/\D/g, '')) : null;
            const count = emptyState ? 0 : (Number.isFinite(parsed) ? parsed : (cards.length ? cards.length : null));
            return { count, cards };
          })
          .catch((error) => { cache.delete(url); throw error; });
        cache.set(url, pending);
      }
      return cache.get(url);
    }

    async function priorityHandles() {
      const handle = root.dataset.priorityCollection;
      if (!handle) return new Set();
      try {
        const data = await collectionData(handle, null);
        return new Set(data.cards.map((product) => product.url.split('?')[0]));
      } catch (_) {
        return new Set();
      }
    }

    function rank(products, priority) {
      return products.map((product, index) => ({ product, index })).sort((a, b) => {
        const score = (entry) => entry.index
          - (entry.product.vendor.toLowerCase() === 'magicholz' ? 2 : 0)
          - (priority.has(entry.product.url.split('?')[0]) ? 2 : 0);
        return score(a) - score(b) || a.index - b.index;
      }).slice(0, 6).map((entry) => entry.product);
    }

    function productCard(product) {
      const link = node('a', 'mh-gf__product');
      link.href = product.url;
      if (product.image) {
        const image = node('img');
        image.src = product.image;
        image.alt = product.imageAlt || product.title;
        image.loading = 'lazy';
        link.appendChild(image);
      }
      const body = node('span', 'mh-gf__product-body');
      body.appendChild(node('strong', '', product.title));
      if (product.price) body.appendChild(node('small', '', product.price));
      link.appendChild(body);
      return link;
    }

    async function showResults() {
      const request = ++state.request;
      ++state.renderVersion;
      root.classList.add('mh-gf--results');
      setProgress(4);
      back.hidden = false;
      skip.hidden = false;
      back.textContent = t('edit', 'Antworten ändern');
      skip.textContent = t('restart', 'Neu starten');
      const heading = node(titleTag, '', t('results-heading', 'Deine Geschenkideen'));
      heading.tabIndex = -1;
      question.replaceChildren(heading);
      heading.focus();
      status.textContent = t('results-loading', 'Wir suchen passende Geschenke …');
      status.classList.add('mh-gf__status--loading');

      let handle = state.answers.interest || 'geschenkefinder';
      let budget = state.answers.budget;
      let note = '';
      let data;
      try {
        data = await collectionData(handle, budget);
        if (data.count === 0 && handle !== 'geschenkefinder') {
          handle = 'geschenkefinder';
          data = await collectionData(handle, budget);
          note = t('fallback-interest', 'Zum gewählten Thema gibt es gerade keine Treffer. Hier sind andere Ideen im gleichen Preisbereich.');
        }
        if (data.count === 0 && budget) {
          budget = null;
          data = await collectionData(handle, budget);
          note = t('fallback-budget', 'In diesem Preisbereich gibt es gerade keine Treffer. Hier sind Ideen ohne Budgetgrenze.');
        }
      } catch (_) {
        if (request !== state.request) return;
        status.classList.remove('mh-gf__status--loading');
        status.textContent = t('results-error', 'Die Vorschläge konnten gerade nicht geladen werden. Öffne die passenden Geschenke direkt in der Kollektion.');
        const all = node('a', 'mh-gf__all', t('link-gifts', 'Geschenke ansehen'));
        all.href = collectionUrl(handle, budget);
        question.appendChild(all);
        return;
      }
      if (request !== state.request) return;
      status.classList.remove('mh-gf__status--loading');
      if (data.count === 0) {
        status.textContent = t('results-zero', 'Für diese Auswahl gibt es gerade keine verfügbaren Geschenke. Ändere eine Antwort oder stöbere in allen Geschenkideen.');
        const all = node('a', 'mh-gf__all', t('link-all-gifts', 'Alle Geschenkideen ansehen'));
        all.href = plainCollectionUrl('geschenkefinder');
        question.appendChild(all);
        return;
      }

      status.textContent = note || t('results-ready', 'Passend zu deiner Auswahl. Du kannst die Antworten jederzeit ändern.');
      if (data.cards.length) {
        const priority = await priorityHandles();
        if (request !== state.request) return;
        const grid = node('div', 'mh-gf__products');
        rank(data.cards, priority).forEach((product) => grid.appendChild(productCard(product)));
        question.appendChild(grid);
      } else {
        status.textContent = t('results-in-collection', 'Passende Produkte findest du direkt in der Kollektion.');
      }
      const all = node('a', 'mh-gf__all', t('link-matching', 'Alle passenden Geschenke ansehen'));
      all.href = collectionUrl(handle, budget);
      question.appendChild(all);
      event('complete', { result_count: data.count, destination_url: all.href });
    }

    back.addEventListener('click', () => {
      state.request += 1;
      state.step = Math.max(0, state.step - 1);
      renderQuestion(true);
    });
    skip.addEventListener('click', () => {
      if (state.step === 4) {
        state.request += 1;
        state.step = 0;
        state.answers = { recipient: null, age: null, interest: null, budget: null };
        renderQuestion(true);
        return;
      }
      const keys = ['recipient', 'age', 'interest', 'budget'];
      const key = keys[state.step];
      state.answers[key] = null;
      keys.slice(state.step + 1).forEach((later) => { state.answers[later] = null; });
      event('skip', { step_index: state.step + 1, category: key });
      state.step += 1;
      if (state.step === 4) showResults();
      else renderQuestion(true);
    });
    if (dictionary && 'MutationObserver' in window) {
      let translationTimer;
      const refreshLanguage = new MutationObserver(() => {
        clearTimeout(translationTimer);
        translationTimer = setTimeout(() => {
          if (state.step === 4) showResults();
          else renderQuestion();
        }, 80);
      });
      refreshLanguage.observe(dictionary, { subtree: true, childList: true, characterData: true });
      const recipients = root.querySelector('.mh-gf__recipients');
      if (recipients) refreshLanguage.observe(recipients, { subtree: true, childList: true, characterData: true });
    }
    renderQuestion();
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-mh-gift-finder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
